import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL fragment
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        console.error('No session_id found');
        // Redirect to auth page, not landing page
        navigate('/auth', { replace: true });
        return;
      }

      try {
        // Exchange session_id for user session
        const response = await axios.get(`${API}/auth/session`, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true
        });

        const userData = response.data;
        setUser(userData);

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect based on onboarding status - ALWAYS to dashboard or onboarding
        if (userData.onboarding_completed) {
          navigate('/dashboard', { replace: true, state: { user: userData } });
        } else {
          navigate('/onboarding', { replace: true, state: { user: userData } });
        }
      } catch (error) {
        console.error('Auth error:', error);
        // Redirect to auth page on error, not landing page
        navigate('/auth', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-900">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#E06D53] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-600 dark:text-slate-400 font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
